import { useMutation, useQuery } from '@apollo/client';
import { message } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RoleCreateContainerStaffRoleCreateDocument, RoleCreateContainerStaffUserCurrentDocument } from '../../../../generated.tsx';
import { useOid } from '../../../../hooks/useOid.ts';
import { ComponentQueryLoader } from '../../../shared/component-query-loader.tsx';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled } from '../../../shared/utils/queryOptions';
import { RoleCreate } from './role-create';

interface RoleCreateContainerProps {}

export const RoleCreateContainer: React.FC<RoleCreateContainerProps> = () => {
  const navigate = useNavigate();

  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled(oid);

  const { data, error, loading } = useQuery(RoleCreateContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);
  const [request, { loading: mutationLoading }] = useMutation(RoleCreateContainerStaffRoleCreateDocument);

  const onSubmit = async (payload: any) => {
    if (data?.staffUserCurrent?.role?.roleSubtype !== 'Staff.IS') {
      payload.roleSubtype = data?.staffUserCurrent?.role?.roleSubtype ?? 'Staff.CaseWorker';
    }

    try {
      const response = await request({
        variables: {
          input: payload
        }
      });

      const roleResponse = response?.data?.staffRoleCreate;
      if (roleResponse?.status?.success === true) {
        message.success('Role created successfully');
        if (roleResponse?.staffRole?.id) {
          navigate(`/staff/roles/detail/${roleResponse?.staffRole?.id}`);
        } else {
          message.error('Failed to create the role');
        }
      } else {
        message.error(`Failed to create the role: ${roleResponse?.status?.errorMessage}`);
      }
    } catch (err: any) {
      message.error(`Failed to create the role: ${err?.message}`);
    }
  };

  return (
    <ComponentQueryLoader
      loading={loading}
      hasData={data}
      error={error}
      hasDataComponent={<RoleCreate onSubmit={onSubmit} roleSubtype={data?.staffUserCurrent?.role?.roleSubtype ?? 'Staff.CaseWorker'} loading={mutationLoading} />}
    />
  );
};
